const APP_ENV = window._env_?.NODE_ENV;

export const vgLog = (...items: unknown[]) => {
  if (APP_ENV === "production") return;

  // eslint-disable-next-line no-console
  // console.log("[VersionGuard]", new Date().toISOString(), ">>>>", ...items);
};

export default vgLog;
